export default function PresetChip({ preset, selected, onSelect, symbol = "€" }) {
  return (
    <div
      className={selected ? "chip sel" : "chip"}
      onClick={() => onSelect(preset.amt)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect(preset.amt);
        }
      }}
    >
      {preset.flag ? (
        <span className={`flag ${preset.flag.cls}`}>{preset.flag.label}</span>
      ) : null}
      {symbol}{preset.amt}
    </div>
  );
}
